import { render, staticRenderFns } from "./CompanyCustomerList.vue?vue&type=template&id=56e77876&"
import script from "./CompanyCustomerList.vue?vue&type=script&lang=js&"
export * from "./CompanyCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports